module.exports = __webpack_public_path__ + "img/download.8ca4ff58.png";